import { Popup, type PopupProps } from '@atlaskit/popup';
import { withChoreographedToggle } from '@atlassian/jira-choreographer-services/src/main.tsx';

export const ChoreographerPopup = withChoreographedToggle<PopupProps>(Popup, 'isOpen', 'content');
